<template>
  <div class="products">
    <h1>Report Prodotti</h1>
    <div class="table-wrap">
        <div>
            <nav aria-label="Pagine">
              <ul class="pagination">
                <li class="page-item">
                  <a class="page-link" href="#" @click="gotoPage(0)">Prima</a>
                </li>
                <li class="page-item" v-show="page>1"><a class="page-link" href="#" @click="gotoPage(page-2)">{{page-1}}</a></li>
                <li class="page-item" v-show="page>0"><a class="page-link" href="#" @click="gotoPage(page-1)">{{page}}</a></li>
                <li class="page-item active" aria-current="page">
                  <span class="page-link">
                    {{page+1}}
                    <span class="sr-only">(current)</span>
                  </span>
                </li>
                <li class="page-item" v-show="page<Math.ceil(count/20)-1"><a class="page-link" href="#" @click="gotoPage(page+1)">{{page+2}}</a></li>
                <li class="page-item" v-show="page<Math.ceil(count/20)-2"><a class="page-link" href="#" @click="gotoPage(page+2)">{{page+3}}</a></li>
                <li class="page-item">
                  <a class="page-link" href="#" @click="gotoPage(Math.ceil(count/20)-1)">Ultima</a>
                </li>
              </ul>
            </nav>
        </div>
        <div class="table-responsive">
          <table>
            <tr>
              <td width="">Prodotto</td>
              <td width="">Brand</td>
              <td width="">Categoria</td>
              <td width="">FID</td>
              <td width="">Data</td>
              <!-- <td width="">EAN</td> -->
              <td width="">Valore</td>
              <td v-for="website in websites" v-bind:key="website" v-if="websites && websites.length > 0">{{ website.name }}</td>
              <td width="200" align="center">Azioni</td>
            </tr>
            <tr>
              <td width=""><input type="text" placeholder="nome" v-model="filters.name"></td>
              <td width=""><input type="text" placeholder="brand" v-model="filters.brand"></td>
              <td width=""><input type="text" placeholder="category" v-model="filters.category"></td>
              <td width=""><input type="text" placeholder="fid" v-model="filters.sku"></td>
              <td width=""></td>
              <!-- <td width=""><input type="text" placeholder="ean" v-model="filters.ean"></td> -->
              <td width=""></td>
              <td v-for="website in websites" v-bind:key="website" v-if="websites && websites.length > 0"></td>
              <td width="200" align="center">
                  <button class="src_btn" @click="getProducts">Cerca</button>
              </td>
            </tr>
            <tr v-for="product in products" v-bind:key="product" v-if="products && products.length > 0">
              <td>{{ product.name }}</td>
              <td>{{ product.brand }}</td>
              <td>{{ product.category }}</td>
              <td>{{ product.sku }}</td>
              <td>{{ formatDate(product.date) }}</td>
              <!-- <td>{{ product.ean }}</td> -->
              <!-- <td>{{ product.price }}</td> -->
              <td>
                {{ getLastPrice(product, '5c9d06465113ce29c23e462f') }}
              </td>
              <td v-for="website in websites" v-bind:key="website" v-if="websites && websites.length > 0">
                {{ getLastPrice(product, website._id) }}
              </td>
              <td></td>
            </tr>
            <tr v-else>
              <td colspan="5"> Nessun prodotto corrispondente ai criteri di ricerca!</td>
            </tr>
          </table>
      </div>
      <div>
          <nav aria-label="Pagine">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link" href="#" @click="gotoPage(0)">Prima</a>
              </li>
              <li class="page-item" v-show="page>1"><a class="page-link" href="#" @click="gotoPage(page-2)">{{page-1}}</a></li>
              <li class="page-item" v-show="page>0"><a class="page-link" href="#" @click="gotoPage(page-1)">{{page}}</a></li>
              <li class="page-item active" aria-current="page">
                <span class="page-link">
                  {{page+1}}
                  <span class="sr-only">(current)</span>
                </span>
              </li>
              <li class="page-item" v-show="page<Math.ceil(count/20)-1"><a class="page-link" href="#" @click="gotoPage(page+1)">{{page+2}}</a></li>
              <li class="page-item" v-show="page<Math.ceil(count/20)-2"><a class="page-link" href="#" @click="gotoPage(page+2)">{{page+3}}</a></li>
              <li class="page-item">
                <a class="page-link" href="#" @click="gotoPage(Math.ceil(count/20)-1)">Ultima</a>
              </li>
            </ul>
          </nav>
      </div>
    </div>
  </div>
</template>

<script>
import ProductsService from '@/services/ProductsService'
export default {
  name: 'ReportTableWebsites',
  data () {
    return {
      page: 0,
      count: 0,
      filters: [],
      products: [],
      websites: []
    }
  },
  mounted () {
    this.getProducts()
  },
  methods: {
    gotoPage (page) {
        this.page = page
        this.getProducts()
    },
    async getProducts () {
      // console.log(this.filters.sku)
      console.log(this.page)
      const response = await ProductsService.reporttable({sku: this.filters.sku, name: this.filters.name, brand: this.filters.brand, category: this.filters.category, page: this.page})
      this.websites = response.data.websites
      this.products = response.data.products
      this.count = response.data.count
      // console.log(this.products)
    },
    formatDate (value) {
        if (!value) {
            return ''
        }
        var date = new Date(value)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },
    getLastPrice (product, websiteId) {
      console.log(websiteId)
      // console.log(product.results[websiteId])
      if (product === undefined || product.results === undefined || product.results[websiteId] === undefined) {
        return ''
      }
      return product.results[websiteId].lastprice.price
    }
  }
}
</script>
<style type="text/css">
.table-wrap {
  /*width: 80%;
  margin: 0 auto;*/
  text-align: center;
}
table {
  /*width: 100%;*/
}
table th, table tr {
  text-align: left;
}
table thead {
  background: #f2f2f2;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #4d7ef7;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
.src_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: auto!important;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportTableWebsites.vue